<template>
  <div class="main-content">
    <avue-crud
      ref="crud"
      :data="tableData"
      :option="option"
      :table-loading="showLoading"
      :page.sync="page"
      @on-load="onLoad"
    >
      <template #header>
        <div>
          <div class="flex flex-wrap align-items marginBottom20">
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >设备ID :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.deviceId"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >设备名称 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.name"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >所属用户/ID :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.userId"
                  placeholder="请输入所属用户名称/ID"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >手机号码 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.phone"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >所属分组/ID :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.groupId"
                  placeholder="请输入分组名称/ID"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >所属网关/ID :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.gatewayId"
                  placeholder="请输入网关名称/ID"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >在线状态 :
              </span>
              <div class="width300">
                <el-select
                  class="width250"
                  v-model="searchData.state"
                  clearable
                >
                  <el-option
                    v-for="(i, index) in OPresence"
                    :value="i.value"
                    :label="i.label"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >是否正常 :
              </span>
              <div class="width300">
                <el-select
                  class="width250"
                  v-model="searchData.runState"
                  clearable
                >
                  <el-option
                    v-for="(i, index) in OERunningState"
                    :value="i.value"
                    :label="i.label"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >分合闸 :
              </span>
              <div class="width300">
                <el-select
                  class="width250"
                  v-model="searchData.floodgateState"
                  clearable
                >
                  <el-option
                    v-for="(i, index) in OGateState"
                    :value="i.value"
                    :label="i.label"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
            </div>

            <el-button
              size="medium"
              type="primary"
              @click="handleSearch"
              style="margin-bottom: 10px"
              class="marginLeft10"
              >搜索</el-button
            >
            <el-button
              size="medium"
              type="info"
              @click="handleReset"
              class="marginLeft10"
              style="margin-bottom: 10px"
              >重置</el-button
            >
          </div>
        </div>
      </template>
      <template slot="state" slot-scope="{ row }">
        <div>
          {{
            row.state == EPresence.onLine
              ? MPresence[row.state]
              : row.state == EPresence.offline
              ? MPresence[row.state]
              : ""
          }}
        </div>
      </template>
      <template slot="runState" slot-scope="{ row }">
        <div>
          {{
            row.runState == ERunningState.normal
              ? MERunningState[row.runState]
              : row.runState == ERunningState.giveAnAlarm
              ? MERunningState[row.runState]
              : row.runState == ERunningState.fault
              ? MERunningState[row.runState]
              : row.runState == ERunningState.Displacement
              ? MERunningState[row.runState]
              : ""
          }}
        </div>
      </template>
      <template slot="floodgateState" slot-scope="{ row }">
        <div>
          {{
            row.floodgateState == EGateState.opening
              ? MGateState[row.floodgateState]
              : row.floodgateState == EGateState.Closing
              ? MGateState[row.floodgateState]
              : ""
          }}
        </div>
      </template>
      <template slot="voltage" slot-scope="{ row }">
        <div>
          {{
            row.productPoleNumber == 6 ||
            row.productPoleNumber == 7 ||
            row.productPoleNumber == 8
              ? row.APhaseVoltage
              : row.productPoleNumber == 3 || row.productPoleNumber == 5
              ? `${row.ABLineVoltage}，${row.BCLineVoltage}，${row.CALineVoltage}`
              : row.productPoleNumber == 4
              ? `${row.APhaseVoltage}，${row.BPhaseVoltage}，${row.CPhaseVoltage}`
              : ""
          }}
        </div>
      </template>
      <template slot="current" slot-scope="{ row }">
        <div>
          {{
            row.productPoleNumber == 6 ||
            row.productPoleNumber == 7 ||
            row.productPoleNumber == 8
              ? row.APhaseCurrent
              : row.productPoleNumber == 3 || row.productPoleNumber == 5
              ? `${row.APhaseCurrent != undefined ? row.APhaseCurrent : ""}，${
                  row.BPhaseCurrent != undefined ? row.BPhaseCurrent : ""
                }，${row.CPhaseCurrent != undefined ? row.CPhaseCurrent : ""}`
              : row.productPoleNumber == 4
              ? `${row.APhaseCurrent != undefined ? row.APhaseCurrent : ""}，${
                  row.BPhaseCurrent != undefined ? row.BPhaseCurrent : ""
                }，${row.CPhaseCurrent != undefined ? row.CPhaseCurrent : ""}`
              : ""
          }}
        </div>
      </template>
      <template slot="totalActivePower" slot-scope="{ row }">
        <div>
          {{
            row.productPoleNumber == 6 ||
            row.productPoleNumber == 7 ||
            row.productPoleNumber == 8
              ? row.totalActivePower
              : row.productPoleNumber == 3 || row.productPoleNumber == 5
              ? `${row.totalActivePower}`
              : row.productPoleNumber == 4
              ? `${
                  row.APhaseActivePower != undefined
                    ? row.APhaseActivePower
                    : ""
                }，${
                  row.BPhaseActivePower != undefined
                    ? row.BPhaseActivePower
                    : ""
                }，${
                  row.CPhaseActivePower != undefined
                    ? row.CPhaseActivePower
                    : ""
                }，${
                  row.totalActivePower != undefined ? row.totalActivePower : ""
                }`
              : ""
          }}
        </div>
      </template>
      <template slot="totalActiveEnergy" slot-scope="{ row }">
        <div>
          {{
            row.productPoleNumber == 6 ||
            row.productPoleNumber == 7 ||
            row.productPoleNumber == 8 ||
            row.productPoleNumber == 3 ||
            row.productPoleNumber == 5 ||
            row.productPoleNumber == 4
              ? row.totalActiveEnergy
              : ""
          }}
        </div>
      </template>
      <template slot="internalHumidity" slot-scope="{ row }">
        <div>
          {{ row.internalHumidity != undefined ? row.internalHumidity : "" }}
        </div>
      </template>
      <template slot="totalHealth" slot-scope="{ row }">
        <div>
          {{ row.totalHealth != undefined ? row.totalHealth : "" }}
        </div>
      </template>
    </avue-crud>
  </div>
</template>

<script>
import { deviceList } from "@/api/collect/device";
import dayjs from "dayjs";
import {
  EPresence,
  MPresence,
  ERunningState,
  MERunningState,
  EGateState,
  MGateState,
  OGateState,
  OERunningState,
  OPresence,
} from "@/enums/beCurrent/EBeCurrent";

export default {
  name: "index",
  data() {
    return {
      EPresence: EPresence,
      MPresence: MPresence,
      ERunningState: ERunningState,
      MERunningState: MERunningState,
      EGateState: EGateState,
      MGateState: MGateState,
      OGateState: OGateState,
      OERunningState: OERunningState,
      OPresence: OPresence,
      searchData: {
        title: "",
        createTime: "",
        userId: this.$route.query.id || "",
      },
      page: {
        total: 0,
        currentPage: 1,
      },
      tableData: [],
      showLoading: false,
      showLoadingForm: false,
      dialogVisible: false,
      selectedRowKeys: [], //表格勾选中的数据
      option: {
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: false, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        page: true, // 显示分页
        align: "center",
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        menu: false,
        column: [
          {
            label: "断路器名称",
            prop: "name",
          },
          {
            label: "型号",
            prop: "productSpecModel",
          },
          {
            label: "所属用户",
            prop: "nickname",
          },
          {
            label: "手机号",
            prop: "phone",
          },
          {
            label: "所属分组",
            prop: "groupName",
          },
          {
            label: "所属网关",
            prop: "gatewayName",
          },
          {
            label: "在线状态",
            prop: "state",
          },
          {
            label: "断路器状态",
            prop: "runState",
          },
          {
            label: "分合闸",
            prop: "floodgateState",
          },
          {
            label: "当前电压V",
            prop: "voltage",
          },
          {
            label: "当前电流A",
            prop: "current",
          },
          {
            label: "当前功率W",
            prop: "totalActivePower",
          },
          {
            label: "当前电能Wh",
            prop: "totalActiveEnergy",
          },
          {
            label: "当前显示温度℃",
            prop: "internalHumidity",
            width: 110,
          },
          {
            label: "当前健康度%",
            prop: "totalHealth",
          },
        ],
      },

      dialogVisible: false,
      form: {
        id: "",
        // sort: " ",
        title: "",
        details: "",
      },
    };
  },
  created() {},
  methods: {
    onLoad() {
      this.showLoading = true;
      const searchData = {
        ...this.searchData,
      };
      if (this.searchData.createTime) {
        searchData.bindTimeStart = dayjs(this.searchData.createTime[0]).format(
          "YYYY-MM-DD 00:00:00"
        );
        searchData.bindTimeEnd = dayjs(this.searchData.createTime[1]).format(
          "YYYY-MM-DD 23:59:59"
        );
      }
      delete searchData.createTime;
      deviceList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...searchData,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }
      });
    },

    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 重置
    handleReset() {
      // console.log('重置')
      this.searchData = {
        state: "",
        name: "",
        createTime: "",
      };
      this.page.currentPage = 1;
      this.onLoad();
    },

    //输入
    salaryDianChange(e, t) {
      const value = e.target.value;
      this.form[t] = value;
    },
  },
};
</script>

<style scoped></style>
